import React from 'react'
import ReactDOM from 'react-dom'
import { ModalProps, Modal } from '~/components/shared'

export interface PortalModalProps extends ModalProps {
  children: React.ReactNode
}

export const PortalModal: React.FC<PortalModalProps> = ({ children, ...props }: PortalModalProps): JSX.Element => {
  const root = document.getElementById('root')
  return root ? ReactDOM.createPortal(<Modal {...props}>{children}</Modal>, root) : <Modal {...props}>{children}</Modal>
}
